import { render } from "./ManzaCard.vue?vue&type=template&id=e2d7d65c&scoped=true"
import script from "./ManzaCard.vue?vue&type=script&lang=ts"
export * from "./ManzaCard.vue?vue&type=script&lang=ts"

import "./ManzaCard.vue?vue&type=style&index=0&id=e2d7d65c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2d7d65c"

export default script